import { render, staticRenderFns } from "./CAxACGxThoughtPt1Page.vue?vue&type=template&id=4235f84a"
import script from "./CAxACGxThoughtPt1Page.vue?vue&type=script&lang=js"
export * from "./CAxACGxThoughtPt1Page.vue?vue&type=script&lang=js"
import style0 from "./CAxACGxThoughtPt1Page.vue?vue&type=style&index=0&id=4235f84a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports